require.config({
    'enforceDefine': true,
    'urlArgs': "psv=10",
    'waitSeconds': 7,
    config: {
        'ps/sentry' : {
            dns: 'https://e31761bbc389430ab2ee7145874b61e5@sentry.io/134668'
        }
    },
    'paths': {
        // ZACHOWAĆ KOLEJNOŚĆ ALFABETYCZNĄ!
        'bootstrap': '../vendor/bootstrap-3.3.6/js/bootstrap',

        'googleMaps': '//maps.google.com/maps/api/js?sensor=false&key=AIzaSyA_0Hun9wLWyfEkruuBCJKp_Lzi_-I_3UU',
        'googleMaps.infoBox': '../vendor/google-maps/infobox',
        'googleMaps.markerClusterer': '../vendor/google-maps/markerClusterer',

        'leaflet': '../vendor/leaflet-1.3.3/leaflet',
        'leaflet-css': '../vendor/leaflet-1.3.3/leaflet',
        'leaflet-markercluster' : '../vendor/leaflet.markercluster-1.4.1/dist/leaflet.markercluster',
        'leaflet-markercluster-css' : '../vendor/leaflet.markercluster-1.4.1/dist/MarkerCluster',
        'leaflet-markercluster-default-css' : '../vendor/leaflet.markercluster-1.4.1/dist/MarkerCluster.Default',

        'jquery': '../vendor/jquery-1.12.4/jquery',
        'jquery.cookie': '../vendor/jquery.cookie-1.4.1/jquery.cookie',

        'jquery.intlTelInput': '../vendor/intl-tel-input/js/intlTelInput',
        'jquery.intlTelInputUtilites': '../vendor/intl-tel-input/js/utils',
        'jquery.intlTelInput-css': '../vendor/intl-tel-input/css/intlTelInput',

        'jquery.lazyload': '../vendor/jquery.lazyload-1.9.7/jquery.lazyload',
        'jquery.select2': '../vendor/jquery.select2-4.0.3/dist/js/select2',
        'jquery.select2-css': '../vendor/jquery.select2-4.0.3/dist/css/select2',

        'jquery.slick': '../vendor/slick-1.4.1/slick',
        'jquery.slick-css': '../vendor/slick-1.4.1/slick',
        'jquery.slick-theme-css': '../vendor/slick-1.4.1/slick-theme',

        'jquery.ui': '../vendor/jquery-ui-1.11.4/jquery-ui',
        'jquery.ui.theme-css' : '../vendor/jquery-ui-1.11.4/jquery-ui-themes/custom/jquery-ui-1.10.2.custom',

        'modernizr': '../vendor/modernizr/modernizr.custom.33587',

        'moment' : [
            '../vendor/moment-2.14.1/moment-with-locales'
        ],

        'require-css': '../vendor/require-css/require-css',

        'sentry' : '//cdn.ravenjs.com/3.9.2/raven.min',

        'wow': '../vendor/WOW-1.1.0/dist/wow',
        'wow-css': '../vendor/WOW-1.1.0/css/libs/animate'
    },
    'shim': {
        'bootstrap': {
            'deps': ['jquery'],
            'exports': 'jQuery'
        },

        'googleMaps': {
            'exports' : 'google'
        },

        'googleMaps.infoBox': {
            'deps': ['googleMaps'],
            'exports': 'InfoBox'
        },

        'googleMaps.markerClusterer': {
            'deps': ['googleMaps'],
            'exports': 'MarkerClusterer'
        },

        'leaflet-markercluster': {
            'deps': ['leaflet']
        },

        'jquery.intlTelInput': {
            'deps': ['jquery', 'jquery.intlTelInputUtilites'],
            'exports': 'jQuery'
        },

        'jquery.intlTelInputUtilites': {
            'deps': ['jquery', 'ps/utils', 'require-css!jquery.intlTelInput-css@after:index'],
            'exports': 'jQuery'
        },

        'jquery.select2': {
            'deps': [
                'jquery',
                'require-css!jquery.select2-css@before:index'
            ],
            'exports': 'jQuery.fn.select2'
        },

        'jquery.slick': {
            'deps': [
                'jquery',
                'require-css!jquery.slick-css@before:index',
                'require-css!jquery.slick-theme-css@before:index'
            ],
            'exports': 'jQuery'
        },

        'jquery.ui' : {
            'deps': [
                'jquery',
                'require-css!jquery.ui.theme-css@before:index'
            ],
            'exports': 'jQuery'
        },

        'modernizr': {
            'exports': 'Modernizr'
        },

        'wow': {
            'deps': [
                'require-css!wow-css@before:index'
            ],
            'exports': 'WOW'
        }
    },
    'packages': [{
        'name': 'ps',
        'location': 'ps'
    }, {
        'name': 'jquery.validate',
        'main': 'jquery.validate',
        'location': '../vendor/jquery.validate-1.15.0'
    }]
});